import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { WIDE_SIZE_CROPPER_CONFIG } from '@tripointe/tripointe-cms/constants';
import { CropperComponent } from 'angular-cropperjs';
@Component({
  selector: 'tp-image-cropper-full-size',
  templateUrl: './image-cropper-full-size.component.html',
  styleUrls: ['./image-cropper-full-size.component.scss']
})
export class ImageCropperFullSizeComponent implements OnInit {
  @Input() imgUrl: string;
  @ViewChild('angularCropper', { static: false }) angularCropper: CropperComponent;

  config = WIDE_SIZE_CROPPER_CONFIG;
  constructor() {}

  ngOnInit(): void {}

  save(): HTMLCanvasElement {
    return this.angularCropper.cropper.getCroppedCanvas();
  }
}
